import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=63b599e7&"
import script from "./Text.vue?vue&type=script&lang=ts&"
export * from "./Text.vue?vue&type=script&lang=ts&"
import style0 from "./Text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b599e7')) {
      api.createRecord('63b599e7', component.options)
    } else {
      api.reload('63b599e7', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=63b599e7&", function () {
      api.rerender('63b599e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Text.vue"
export default component.exports